import React, {Fragment} from 'react';

import {DISCOUNT_MAIN_TYPES, DISCOUNT_MODES, DISCOUNT_TYPES} from "./discounstInterface";
import {
  getPriceWithCurrency,
  getQuotePriceWithDiscounts, getQuotePriceWithTaxes,
  getTotalPrice,
  sortByOrder,
  toFixedPrice
} from "../../misc/helpers";
import {
  getCustomDepositAmount,
  getDiscountsForSection,
  getSubTotalPrice,
  shouldDisplayDiscount
} from "./discountFunctions";
import TextInput from "../ui/textInput";

export default class DiscountCommon extends React.Component {

  handleDiscountSelectClick = () => {
    if (this.isDiscountDisabled()) {
      return false
    }
    const currentDiscount = this.props.discount;
    currentDiscount.selected = !currentDiscount.selected;
    this.updateDiscount(currentDiscount);
  };

  setDiscountProperty = (property, value) => {
    const currentDiscount = this.props.discount;
    currentDiscount[property] = value;
    this.updateDiscount(currentDiscount);
  };

  updateDiscount = (currentDiscount) => {
    this.props.setDiscountSections(this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        discountSection.discounts.map(discount => {
          if (currentDiscount.order === discount.order) {
            return currentDiscount
          }
          return discount
        });
        if (currentDiscount.selected && currentDiscount.mode === DISCOUNT_MODES.or && !currentDiscount.isSubTotal) {
          discountSection.discounts = discountSection.discounts.map(discount => {
            if ((currentDiscount.order !== discount.order) && (discount.mode === DISCOUNT_MODES.or) && !discount.isSubTotal) {
              discount.selected = false
            }
            return discount
          });
        }
      }
      return discountSection
    }));
  };

  getGrandTotal = (withoutDiscount = null) => {
    const totalPrice = getTotalPrice(null, false);
    return getQuotePriceWithDiscounts(totalPrice, withoutDiscount ? [withoutDiscount] : []);
  }

  isDiscountDisabled = (forDiscount = this.props.discount) => {
    const {discountSection, customAddedDiscounts} = this.props;
    const discount = forDiscount;
    if (discount.selected) {
      return false
    }
    const grandTotal = this.getGrandTotal();
    const discountAmount = discount.type === DISCOUNT_TYPES.price ? discount.amount : grandTotal * discount.amount / 100;
    let disabled = (grandTotal - discountAmount) < 0;
    if (disabled && discount.mode === DISCOUNT_MODES.or) {
      const allDiscounts = sortByOrder(getDiscountsForSection(discountSection, customAddedDiscounts));
      if (allDiscounts.some(currentDiscount => {
        return (currentDiscount.order !== discount.order) // take othere discounts from this section
          && (currentDiscount.mode === DISCOUNT_MODES.or) // with OR mode
          && shouldDisplayDiscount(currentDiscount) // already selected
          && (this.getGrandTotal(currentDiscount) - discountAmount) > 0
        // price without this discount minus current discount amount still more than 0
      })) {
        disabled = false
      }
    }
    return disabled
  }

  getDiscountPercentageAmount = () => {
    const grandTotal = getSubTotalPrice(this.props.discountSections, this.props.discountSection, this.props.discount, true, this.props.customAddedDiscounts);
    const priceTaken = grandTotal * this.props.discount.amount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

  setAmountValue = (value) => {
    // console.log("value", value);
    if ((this.props.discount.discountType === DISCOUNT_MAIN_TYPES.deposit) && (this.props.discount.type === DISCOUNT_TYPES.percent)) {
      this.setDiscountProperty("type", DISCOUNT_TYPES.price);
    }
    this.setDiscountProperty("amount", +value)
  };

  getMaxDiscountValue = () => {
    return (this.props.discount.type === DISCOUNT_TYPES.percent) ? 100 : this.getGrandTotal(this.props.discount)
  }

  getDiscountAmount = () => {
    const {discount, fabricatorSettings} = this.props;
    return discount.type === DISCOUNT_TYPES.price
      ? "-" + getPriceWithCurrency(fabricatorSettings, discount.amount)
      : "-" + getPriceWithCurrency(fabricatorSettings, this.getDiscountPercentageAmount())
  }

  getInputValue = () => {
    const {discount, fabricatorSettings, discountSections} = this.props;
    if (!discount.amount) {
      return "0"
    }
    if (discount.discountType === DISCOUNT_MAIN_TYPES.deposit) {
      if (discount.type === DISCOUNT_TYPES.price) {
        return getPriceWithCurrency(fabricatorSettings, toFixedPrice(discount.amount))
      }
      const totalPrice = getTotalPrice();
      const grandTotal = getQuotePriceWithTaxes(totalPrice);
      const customDepositAmount = getCustomDepositAmount(discountSections, grandTotal);
      return getPriceWithCurrency(fabricatorSettings, customDepositAmount);
    }
    // return "-" + (discount.type === DISCOUNT_TYPES.price) // we can't have percentages free fill discounts
    //   ? fabricatorSettings.currencySign + discount.amount
    //   : discount.amount + "%"
    return "-" + getPriceWithCurrency(fabricatorSettings, toFixedPrice(discount.amount))
  }

  renderAmountInput = () => {
    const {discount, fabricatorData} = this.props;
    const isDiscount = discount.discountType === DISCOUNT_MAIN_TYPES.deposit;
    return discount.selected || isDiscount ? (
      <Fragment>
        {/*<span className="discount-special__type">*/}
        {/*  -{discount.type === DISCOUNT_TYPES.percent ? "%" : fabricatorData.settings.currencySign}*/}
        {/*</span>*/}
        <TextInput className={"ui-input discount-special__amount discount-cell--active-color price-input"}
                   numberInput={true}
                   onChange={this.setAmountValue}
                   onRealChange={this.setAmountValue}
                   maxValue={this.getMaxDiscountValue()}
                   currencySing={isDiscount ? fabricatorData.settings.currencySign : "-" + fabricatorData.settings.currencySign}
                   value={this.getInputValue()}/>
        {/*{discount.type === DISCOUNT_TYPES.percent*/}
        {/*  ? <span className="discount-cell--amount">{this.getDiscountAmount()}</span>*/}
        {/*  : null}*/}
      </Fragment>
    ) : null
  }

}
